import BaseSwitch, { SwitchProps as BaseSwitchProps } from 'antd/lib/switch'

export interface SwitchProps extends BaseSwitchProps {}

export const Switch = (props: SwitchProps) => (
  <>
    <BaseSwitch {...props} />
  </>
)

export default Switch
